// This is a navigation projection only; the API independently authorizes every call.
export function canManageLateSubmissionPolicies(user) {
    return (
        window.__INITIAL_STATE__?.EnvironmentSettings?.late_submission_policies_enabled === true &&
        !!user?.hasActiveFeature(window.__INITIAL_STATE__?.Features?.LATE_SUBMISSION_POLICIES) &&
        !!user?.hasAnyRole(['Owner', 'Admin', 'Instruction Admin'])
    );
}

export function canConfigureLateSubmissionPolicies(user) {
    return canManageLateSubmissionPolicies(user) && !!user?.hasAnyRole(['Owner', 'Admin']);
}
